"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _Menu = require("./Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _Item = require("./Item.js");

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.getTotalPrice = function (item) {
    var price = item.price;
    if (!price) price = 0;

    for (var i in item.variationsChoices) {
        for (var j in item.variationsChoices[i]) {
            price += self.getTotalPrice(item.variationsChoices[i][j]);
        }
    }

    var count = item.count;
    if (typeof count === "undefined") {
        count = 1;
    }
    price = price * count;
    return price;
};

self.getOrderItemFromItem = function (item, __itemById, orderTime) {
    var orderItem = {};
    orderItem.itemId = item.id;
    orderItem.price = item.price;
    orderItem.variations = item.variations;
    orderItem.variationsChoices = [];

    _lodash2.default.each(item.variations, function (variation) {
        var choices = [];
        var prices = variation.prices || {};

        _lodash2.default.each(variation.defaults, function (count, subItemId) {
            var subItem = __itemById[subItemId];
            var subOrderItem = self.getOrderItemFromItem(subItem, __itemById, orderTime);
            subOrderItem.price = (prices[subItemId] || {})[1] || 0;

            if (!_Item2.default.isUnavailable(subItem, orderTime) && !_Item2.default.isSoldOut(subItem, orderTime)) {

                choices.push(subOrderItem);
            }
        });
        orderItem.variationsChoices.push(choices);
    });

    return orderItem;
};

self.getAllItemIds = function (orderItem) {
    var temp = [orderItem.itemId];

    _lodash2.default.each(orderItem.variationsChoices || [], function (orderItems) {
        _lodash2.default.each(orderItems, function (orderItem) {
            temp = temp.concat(self.getAllItemIds(orderItem));
        });
    });

    var ret = [];

    for (var i = 0; i < (orderItem.count || 1); i++) {
        ret = ret.concat(temp);
    }

    return ret;
};

function variationsEquals(x, y) {
    if (x.toOpenRestObj) x = x.toOpenRestObj();
    if (y.toOpenRestObj) y = y.toOpenRestObj();

    var p;
    for (p in y) {
        if (p === "displayType") continue;
        if (typeof x[p] == 'undefined') {
            return false;
        }
    }

    for (p in y) {
        if (y[p]) {
            switch ((0, _typeof3.default)(y[p])) {
                case 'object':
                    if (!variationsEquals(x[p], y[p])) {
                        return false;
                    }break;
                case 'function':
                    if (typeof x[p] == 'undefined' || p != 'equals' && y[p].toString() != x[p].toString()) {
                        return false;
                    }
                    break;
                default:
                    if (y[p] != x[p]) {
                        return false;
                    }
            }
        } else {
            if (x[p]) {
                return false;
            }
        }
    }

    for (p in x) {
        if (p === "displayType") continue;
        if (typeof y[p] == 'undefined') {
            return false;
        }
    }

    return true;
}

self.validate = function (orderItem, __itemStatus, __itemById) {
    if (__itemStatus(orderItem.itemId) === "unavailable") {
        return false;
    }

    var variations = orderItem.variations || [];

    if (__itemById) {
        var item = __itemById[orderItem.itemId];
        if (!variationsEquals(item.variations || [], variations)) {
            return false;
        }
    }

    var variationsChoices = orderItem.variationsChoices || [];
    var allOk = true;

    for (var j = 0; j < variations.length; j++) {
        allOk &= validateVariation(variations[j], variationsChoices[j], __itemStatus);
    }

    return allOk;
};

function validateVariation(variation, variationsChoices, __itemStatus, __itemById) {
    var count = 0;
    var valid = true;
    var items = variationsChoices || [];
    var legalItems = variation.itemIds;
    var min = variation.minNumAllowed ? variation.minNumAllowed : 0;
    var max = variation.maxNumAllowed ? variation.maxNumAllowed : items.length;

    for (var i = 0; i < items.length; i++) {
        valid &= inArray(legalItems, items[i].itemId);
        valid &= self.validate(items[i], __itemStatus, __itemById);
        count++;
    }

    if (count > max && max > 0) {
        valid = false;
    }
    if (count < min) {
        valid = false;
    }

    return valid;
}

function inArray(array, val) {
    for (var i in array) {
        if (array[i] === val) return true;
    }
    return false;
}

/**
 * Returns a flatten version of the variations of an order item (ie, all variation in variation are
 * translated to a single flat variations list.
 */
self.flattenVariations = function (_ref) {
    var orderItem = _ref.orderItem,
        _ref$variations = _ref.variations,
        variations = _ref$variations === undefined ? [] : _ref$variations,
        _ref$variationsChoice = _ref.variationsChoices,
        variationsChoices = _ref$variationsChoice === undefined ? [] : _ref$variationsChoice,
        _ref$indent = _ref.indent,
        indent = _ref$indent === undefined ? 0 : _ref$indent;


    _lodash2.default.each(orderItem.variations || [], function (variation, idx) {

        var variationChoiceClone = _lodash2.default.cloneDeep(orderItem.variationsChoices[idx]);
        _lodash2.default.map(variationChoiceClone, function (choice) {
            if (choice.variationsChoices) delete choice.variationsChoices;
            if (choice.variations) delete choice.variations;
        });

        variations.push((0, _extends3.default)({}, variation, { indent: indent }));
        variationsChoices.push(variationChoiceClone);

        _lodash2.default.each(orderItem.variationsChoices[idx], function (choice) {
            self.flattenVariations({ orderItem: choice, variations: variations, variationsChoices: variationsChoices, indent: indent + 1 });
        });
    });

    return { variations: variations, variationsChoices: variationsChoices };
};

/**
 * Adds the following to the order item:
 *      title
 *      description
 *      count (even if 1)
 *      priceEach
 *      variationsDeselected - adds removed defaults
 */
self.getFullOrderItem = function (_ref2) {
    var orderItem = _ref2.orderItem,
        menuFull = _ref2.menuFull,
        itemsHash = _ref2.itemsHash;


    var clone = _lodash2.default.cloneDeep(orderItem); // So we don't change the original component

    if (!itemsHash) {
        itemsHash = _lodash2.default.zipObject(_lodash2.default.map(menuFull.items, 'id'), menuFull.items);
    }

    _lodash2.default.each(clone.variationsChoices || [], function (choices) {
        _lodash2.default.each(choices, function (choice, idx) {
            choices[idx] = self.getFullOrderItem({ orderItem: choice, menuFull: menuFull, itemsHash: itemsHash });
        });
    });

    var variationsDeselected = [];
    var variationsSelectedButNotDefault = [];
    _lodash2.default.each(clone.variations || [], function (variation, idx) {
        var defaults = _lodash2.default.isArray(variation.defaults) ? variation.defaults : _lodash2.default.keys(variation.defaults);
        var choices = _lodash2.default.map(clone.variationsChoices[idx], 'itemId');

        variationsDeselected.push(_lodash2.default.map(_lodash2.default.difference(defaults, choices), function (itemId) {
            return self.getFullOrderItem({ orderItem: { itemId: itemId }, menuFull: menuFull, itemsHash: itemsHash });
        }));
        variationsSelectedButNotDefault.push(_lodash2.default.map(_lodash2.default.difference(choices, defaults), function (itemId) {
            return self.getFullOrderItem({ orderItem: { itemId: itemId }, menuFull: menuFull, itemsHash: itemsHash });
        }));
    });

    var item = itemsHash[clone.itemId.split(':')[0]];
    var totalPrice = self.getTotalPrice(clone);
    var count = clone.count || 1;
    var description = item.description ? { description: item.description } : {};
    variationsDeselected = _lodash2.default.isEmpty(variationsDeselected) ? {} : { variationsDeselected: variationsDeselected };
    variationsSelectedButNotDefault = _lodash2.default.isEmpty(variationsSelectedButNotDefault) ? {} : { variationsSelectedButNotDefault: variationsSelectedButNotDefault };

    return (0, _extends3.default)({}, clone, { title: item.title }, description, { count: count, totalPrice: totalPrice, priceEach: totalPrice / count }, variationsDeselected, variationsSelectedButNotDefault);
};

self.itemVariationsAndCommentToStructure = function (_ref3) {
    var fullOrderItem = _ref3.fullOrderItem,
        stringifyMoney = _ref3.stringifyMoney,
        i18n = _ref3.i18n,
        localizedToStr = _ref3.localizedToStr,
        viewMode = _ref3.viewMode;


    var COMMA = i18n.get('openrest_cartview_delimiter');

    var data = _lodash2.default.compact(_lodash2.default.map(fullOrderItem.variations, function (variation, idx) {

        var title = localizedToStr(variation.title) + ":";
        var textParts = [];

        if (variation.displayType === 'hidden' && viewMode !== 'restaurant') {
            return null;
        }

        if (variation.displayType === 'diff') {
            _lodash2.default.map(fullOrderItem.variationsDeselected[idx], function (choice) {
                textParts.push(i18n.get('openrest_checkoutconfirmationview_without') + " " + (localizedToStr(choice.title) || '').trim());
            });
        }

        _lodash2.default.map(variation.displayType === 'diff' ? fullOrderItem.variationsSelectedButNotDefault[idx] : fullOrderItem.variationsChoices[idx], function (choice) {
            var title = localizedToStr(choice.title || '').trim();

            if ((choice.count || 1) > 1) {
                title = choice.count + '×' + title;
            }

            if (choice.priceEach) {
                title += ' (' + stringifyMoney(choice.priceEach) + ')';
            }
            textParts.push("" + title);
        });

        if (_lodash2.default.isEmpty(textParts)) {
            return null;
        }

        return { title: title, text: textParts.join(COMMA) };
    }));

    if (fullOrderItem.comment) {
        data.push({ title: "" + i18n.get('openrest_checkoutconfirmationview_item_comment'), text: fullOrderItem.comment });
    }

    return data;
};

self.convertOrderItemToExternalOrderItem = function (orderItem) {
    _Menu2.default.convertVariationsToExternalVariations(orderItem.variations || []);

    orderItem.variationsChoices = _lodash2.default.map(orderItem.variationsChoices, function (choices) {
        return _lodash2.default.map(choices, function (_orderItem) {
            return self.convertOrderItemToExternalOrderItem(_orderItem);
        });
    });

    return {
        itemId: orderItem.itemId,
        price: orderItem.price,
        count: orderItem.count || 1,
        comment: orderItem.comment,
        variations: orderItem.variations,
        variationsChoices: orderItem.variationsChoices
    };
};

self.convertOrderItemToInternalOrderItem = function (orderItem) {
    _Menu2.default.convertVariationsToInternalVariations(orderItem.variations || []);

    orderItem.variationsChoices = _lodash2.default.map(orderItem.variationsChoices, function (choices) {
        return _lodash2.default.map(choices, function (_orderItem) {
            return self.convertOrderItemToInternalOrderItem(_orderItem);
        });
    });

    return {
        itemId: orderItem.itemId,
        price: orderItem.price,
        count: orderItem.count,
        comment: orderItem.comment,
        variations: orderItem.variations,
        variationsChoices: orderItem.variationsChoices
    };
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/OrderItem.js
// module id = 287
// module chunks = 0